// extracted by mini-css-extract-plugin
export default {"container":"Game_container__s-AyM","gameOver":"Game_gameOver__UUnxa"};